import { render } from "./DeleteServiceModal.vue?vue&type=template&id=7b21bb8d"
import script from "./DeleteServiceModal.vue?vue&type=script&lang=js"
export * from "./DeleteServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__